// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1_ume","cls2":"FullScreenPremiumModal-cls2_epW FullScreenPremiumModal-cls1_ume"};